import React from "react";
import { IoMdInformationCircleOutline, IoMdCheckmarkCircleOutline } from "react-icons/io";
import { PiWarningBold } from "react-icons/pi";
import { MdOutlineDangerous } from "react-icons/md";

const notificationStyles = {
  primary: {
    bgColor: "bg-[#0091EA]/[0.16]",
    textColor: "text-[#076DAC]",
    icon: <IoMdInformationCircleOutline className='text-xl text-[#076DAC] m-2' />,
  },
  success: {
    // bgColor: "bg-[#60C5C5]/[0.16]",
    bgColor: "bg-[#e0f4f4]",
    textColor: "text-[#006D6D]",
    icon: <IoMdCheckmarkCircleOutline className='text-xl text-[#006D6D] m-2' />,
  },
  warning: {
    bgColor: "bg-[#FF9918]/[0.2]",
    textColor: "text-[#713F00]",
    icon: <PiWarningBold className='text-xl text-[#713F00] m-2' />,
  },
  danger: {
    bgColor: "bg-[#E66464]/[0.16]",
    textColor: "text-[#DC3030]",
    icon: <MdOutlineDangerous className='text-xl text-[#DC3030] m-2' />,
  },
};

const Alert = ({ type, children }) => {
  const style = notificationStyles[type] || notificationStyles.primary;

  return (
    // <div className={`flex items-center p-4 mb-4 ${style.bgColor} rounded-lg`}>
    <div className={`flex items-center p-4 ${style.bgColor} rounded-lg`}>
      {style.icon}
      <span className={`font-medium text-lg ${style.textColor}`}>{children}</span>
    </div>
  );
};

export default Alert;
